import React from 'react';
import { useNavigate } from 'react-router-dom';
import { isAdmin } from 'src/redux/auth/service';
import { RoutesEnum } from 'src/types/navigation';

interface Props {
    taskId?: string;
    title?: string;
}

const TaskTitleLink: React.FC<Props> = ({ taskId, title }) => {
    const navigate = useNavigate();
    if (!title) return null;
    const clickable = isAdmin() && !!taskId;
    const style: React.CSSProperties = clickable ? { cursor: 'pointer' } : {};
    const handleClick = (e: React.MouseEvent) => {
        if (clickable) {
            e.stopPropagation();
            navigate(RoutesEnum.TASK_DETAIL.replace(':id', taskId!));
        }
    };
    return (
        <strong style={style} onClick={handleClick}>
            {title}
        </strong>
    );
};

export default TaskTitleLink;
